<template>
    <FormRoot :loading="loadingTypes">
        <Alert v-if="!isQuoteProcessed" color="info" class="mb-3"
            >N.B.: The end date cannot be updated because the Quote is not processed yet</Alert
        >

        <!-- Start Date -->
        <Field :form.sync="form" name="start_date" type="date" hint="Start of balance validity" />

        <!-- End Date -->
        <Field v-if="isQuoteProcessed" :form.sync="form" name="end_date" type="date" hint="End of balance validity" />

        <!-- Type -->
        <Field
            v-if="hasMultipleQuoteTypes"
            :form.sync="form"
            type="select"
            name="type"
            :options="options"
            optionsKeyBy="technical_name"
            optionsLabel="label"
            placeholder="Type of the Quote"
            hint="Select the specific type of the Quote for which you want to adapt the dates"
            class="mt-3"
        />

        <!-- Button -->
        <FormActions>
            <Submit class="float-right" :disabled="!form.submittable" :loading="form.loading" @click="onSubmit"
                >Update dates</Submit
            >
        </FormActions>
    </FormRoot>
</template>

<script>
    import { Alert, Alerts, Field, FormActions, FormRoot, Submit } from '@tech_hexeko/design-system'
    import Forms from '@/mixins/Forms'

    export default {
        mixins: [Forms],
        components: {
            Alert,
            Field,
            FormActions,
            FormRoot,
            Submit,
        },
        props: {
            quote: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                /** @public - used by Forms mixin */
                fields: {
                    start_date: null,
                    end_date: null,
                    type: null,
                },
                loadingTypes: true,
                /** @public - used by Forms mixin */
                messageSuccess: 'The dates have been updated',
                types: [],
            }
        },
        computed: {
            allowedTypes() {
                return this.quote && this.quote.types
            },
            filteredTypes() {
                return this.types
                    .flatMap((type) => [type, ...(type.children && type.children.length > 0 ? type.children : [])])
                    .map((type) => ({
                        ...type,
                        label: type.name[this.$store.state.lang.displayLanguage],
                    }))
            },
            hasMultipleQuoteTypes() {
                return this.options && this.options.length > 1
            },
            isQuoteProcessed() {
                return this.quote && this.quote.is_processed
            },
            options() {
                return this.filteredTypes.filter((type) => this.allowedTypes.includes(type.technical_name))
            },
            quoteId() {
                return this.quote && this.quote.id
            },
            selectedType() {
                if (this.hasMultipleQuoteTypes) {
                    return this.form.type || null
                } else {
                    return this.options && this.options.length > 0 ? this.options[0].technical_name : null
                }
            },
        },
        methods: {
            async fetchTypes() {
                try {
                    this.loadingTypes = true
                    const types = await this.$api.types.get({ depth: 1, per_page: 100 })
                    this.types = types.data
                } catch (error) {
                    const errorTxt =
                        error && error.response && error.response.data
                            ? error.response.data.message
                            : 'An error occurred while fetching the types'
                    Alerts.notificationError(errorTxt)
                } finally {
                    this.loadingTypes = false
                }
            },
            /** @public - used by Forms mixin */
            submit() {
                return this.$api.billing.quotes.updateDates(this.quoteId, {
                    start_date: this.form.start_date,
                    end_date: this.form.end_date,
                    type: this.selectedType,
                    ...(this.$store.getters.getUser &&
                        this.$store.getters.getUser.id && { user_id: this.$store.getters.getUser.id }),
                })
            },
        },
        mounted() {
            this.fetchTypes()
        },
    }
</script>
